module.exports = __webpack_public_path__ + "static/Group 6-a507a4b607c6b8c4a3062ceb3c96a844.png";